<div class="grid flex align-items-center p-3"
	[class]="onExtendedMobile() ? 'justify-content-center' : 'justify-content-start'">
	<p-button id="addSchedule" label="{{ 'ADD_SCHEDULE' | translate }}" (click)="addSchedule()"
		[disabled]="currentSite=== undefined || !currentSite.CurrentlyOwned" icon="pi cm-plus" [rounded]="false"
		[text]="true" severity="primary" styleClass="font-bold border-primary">
	</p-button>

	<p-table #tableCustomersList dataKey="i" class="col-12" [value]="schedules" [paginator]="true"
		[totalRecords]="totalRecords" [loading]="schedulesLoading" [rows]="pageSize" [showCurrentPageReport]="true"
		currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true" responsiveLayout="stack">

		<ng-template pTemplate="header" class="flex align-items-center justify-content-center">
			<tr>
				<th>
					<div class="flex align-items-center justify-content-center"></div>
				</th>
				<th>
					<div class="flex align-items-center justify-content-center">{{ 'SCHEDULES_NAME' | translate }}</div>
				</th>
				<th>
					<div class="flex align-items-center justify-content-center">{{ 'RUN_SCENARIO' | translate }}</div>
				</th>
				<th>
					<div class="flex align-items-center justify-content-center">{{ 'STARTING_TIME' | translate }}</div>
				</th>
				<th>
					<div class="flex align-items-center justify-content-center">{{ 'START_END_TIME' | translate }}</div>
				</th>
				<th>
					<div class="flex align-items-center justify-content-center">{{ 'REPEAT_TYPE' | translate }}</div>
				</th>
				<th>
					<div class="flex align-items-center justify-content-center">{{ 'FREQUENCY' | translate }}</div>
				</th>
				<th>
					<div class="flex align-items-center justify-content-center">{{ 'EXCLUSIONS_CALENDAR' | translate }}</div>
				</th>
				<th>
					<div class="flex align-items-center justify-content-center"></div>
				</th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-schedule>
			<tr>
				<td class="p-0">
					<span class="p-column-title"></span>
					<p-avatar [style]="getBgColorSchedule(schedule)" [ngClass]="getHeightColorSchedule()"
						[styleClass]="getHeightColorSchedule()"></p-avatar>
				</td>
				<td>
					<span class="p-column-title font-semibold">{{ 'SCHEDULES_NAME' | translate }}</span>
					<div class="flex align-items-center justify-content-center">{{ schedule.Name }}</div>
				</td>
				<td>
					<span class="p-column-title font-semibold">{{ 'RUN_SCENARIO' | translate }}</span>
					<div class="flex align-items-center justify-content-center">{{ getSceneryName(schedule.SceneryId) }}
					</div>
				</td>
				<td>
					<span class="p-column-title font-semibold">{{ 'STARTING_TIME' | translate }}</span>
					<div class="flex align-items-center justify-content-center">{{ getStartingTime(schedule) }}</div>
				</td>
				<td>
					<span class="p-column-title font-semibold">{{ 'START_END_TIME' | translate }}</span>
					<div class="flex align-items-center justify-content-center">{{ getStartEndDate(schedule) }}</div>
				</td>
				<td>
					<span class="p-column-title font-semibold">{{ 'REPEAT_TYPE' | translate }}</span>
					<p-tag [value]="getTypeRepetition(schedule)" [styleClass]="getColorTag(schedule)"></p-tag>
				</td>
				<td>
					<span class="p-column-title font-semibold">{{ 'FREQUENCY' | translate }}</span>
					<div class="flex align-items-center justify-content-center">{{ getFrequency(schedule) }}</div>
				</td>
				<td>
					<span class="p-column-title font-semibold">{{ 'EXCLUSIONS_CALENDAR' | translate }}</span>
					<div class="flex align-items-center justify-content-center">{{ getExclusionsCalendar(schedule) }}</div>
				</td>
				<td>
					<span class="p-column-title font-semibold"></span>
					<div class="flex flex-row justify-content-center align-items-center gap-1">
						<p-button pTooltip="{{ 'EDIT' | translate}}"
							[disabled]="currentSite=== undefined || !currentSite.CurrentlyOwned" tooltipPosition="bottom"
							icon="pi cm-pencil" size="large" (click)="editSchedule(schedule)" [rounded]="false" [text]="true"
							severity="secondary">
						</p-button>
						<p-button pTooltip="{{ 'DELETE' | translate}}"
							[disabled]="currentSite=== undefined || !currentSite.CurrentlyOwned" tooltipPosition="bottom"
							icon="pi cm-trash" size="large" (click)="deleteSchedule(schedule)" [rounded]="false" [text]="true"
							severity="danger">
						</p-button>
					</div>
				</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>